export class Legacy_TopoMarkers {
    documentGoogleMarkers = [];
    documentClusterGoogleMarkers = [];
    _markerClusterer = null;

    archivesGoogleMarkers = [];
    eventListenersArchiveMarker = [];

    galleryGoogleMarkers = [];

    getMarker(id) {
        let self = this;

        if (id && self.documentGoogleMarkers) {
            let m = [];

            for (let i = 0; i < self.length; i++) {
                if (self.documentGoogleMarkers[i].rel === id) {
                    m.push(self.documentGoogleMarkers[i]);
                }
            }
            return m;
        }
        return null;
    }

    deleteDocumentMarkers() {
        if (this.documentGoogleMarkers.length) {

            while (this.documentGoogleMarkers.length) {
                let mi = this.documentGoogleMarkers.pop();
                mi.setMap(null);
            }

            if (this._Clusterer) {
                let clusterMarkers = this._Clusterer.markers;

                while (clusterMarkers.length) {
                    let clusterMarker = clusterMarkers.pop();
                    clusterMarker.setMap(null);
                }

                this._Clusterer.clearMarkers();
            }
        }
    }

    deleteOtherArchiveMarkers() {
        while (this.eventListenersArchiveMarker.length) {
            let el = this.eventListenersArchiveMarker.pop();
            google.maps.event.clearListeners(el);
        }

        while (this.archivesGoogleMarkers.length) {
            let m = this.archivesGoogleMarkers.pop();
            m.setMap(null);
        }
    }
}

